enum ActionTypes {
    SET_WORKSPACE_WARNING_DETAILS = "app/setWorkspaceWarningDetails",
    RESET_WORKSPACE_WARNING_DETAILS = "app/resetWorkspaceWarningDetails",
}

export default ActionTypes;
